@if (asAccordion) {
	<div class="accordion accordion-flush" id="filterGroupAccordion">
		@for (filter of filters; track filter.id) {
			<fieldset>
				<div class="accordion-item">
					<h3 class="accordion-header" [id]="filter.id">
						<button
							class="accordion-button collapsed"
							type="button"
							data-bs-toggle="collapse"
							[attr.data-bs-target]="'#collapse' + filter.id"
							aria-expanded="true"
							[attr.aria-controls]="'collapse' + filter.id">
							<legend>
								<span>
									{{ filter.label }}
								</span>
							</legend>
						</button>
					</h3>
					<div
						[id]="'collapse' + filter.id"
						class="accordion-collapse collapse"
						[attr.aria-controls]="filter.id"
						data-bs-parent="#filterGroupAccordion">
						<div class="accordion-body link-list-wrapper pb-4">
							@switch (filter.type) {
								@case (filterType.RADIO) {
									<app-radio
										[genericConfig]="filter"
										(radioSelected)="onFilterChange($event)"></app-radio>
								}
								@case (filterType.CHECKBOX) {
									<app-checkbox
										[genericConfig]="filter"
										(checkboxToggled)="onFilterChange($event)"></app-checkbox>
								}
								@case (filterType.CONTEXTUALIZED_SELECTS) {
									<app-contextualized-selects
										[genericConfig]="filter"
										(optionChanged)="onFilterChange($event)"></app-contextualized-selects>
								}
								@case (filterType.AUTOCOMPLETE) {
									<app-autocomplete-text
										[genericConfig]="filter"
										(autocompleted)="onFilterChange($event)"></app-autocomplete-text>
								}
								@case (filterType.EXCLUSIVE) {
									<app-exclusive-filters
										[genericConfig]="filter"
										(selectedFilterChanged)="this.onFilterChange($event)"
										(filterSelected)="
											this.onExclusiveFilterSelection($event)
										"></app-exclusive-filters>
								}
							}
						</div>
					</div>
				</div>
			</fieldset>
		}
	</div>
} @else {
	@for (filter of filters; track filter.id) {
		<div class="border-bottom border-black mb-4">
			<h3 tabindex="0">
				{{ filter.label }}
			</h3>
			@switch (filter.type) {
				@case (filterType.RADIO) {
					<app-radio [genericConfig]="filter" (radioSelected)="onFilterChange($event)"></app-radio>
				}
				@case (filterType.CHECKBOX) {
					<app-checkbox [genericConfig]="filter" (checkboxToggled)="onFilterChange($event)"></app-checkbox>
				}
				@case (filterType.CONTEXTUALIZED_SELECTS) {
					<app-contextualized-selects
						[genericConfig]="filter"
						(optionChanged)="onFilterChange($event)"></app-contextualized-selects>
				}
				@case (filterType.AUTOCOMPLETE) {
					<app-autocomplete-text
						[genericConfig]="filter"
						(autocompleted)="onFilterChange($event)"></app-autocomplete-text>
				}
				@case (filterType.EXCLUSIVE) {
					<app-exclusive-filters
						[genericConfig]="filter"
						(selectedFilterChanged)="this.onFilterChange($event)"
						(filterSelected)="this.onExclusiveFilterSelection($event)"></app-exclusive-filters>
				}
			}
		</div>
	}
}
